import React from 'react';
import SiteHeader from '@/components/siteChrome/SiteHeader';
import SiteFooter from '@/components/siteChrome/SiteFooter';
import './helpCentre.css';

interface HelpCentreLayoutProps {
  children: React.ReactNode;
  /**
   * The hub renders on the shared `--hc-bg` grey page with white cards. The
   * article page inverts that: it renders on white (`--hc-page-bg` resolves
   * to `--hc-surface`) so the grey accent fills (the read-time pill, the
   * "On this page" card, the Previous/Next cards) read as distinct surfaces
   * instead of grey-on-grey. Defaults to 'hub'.
   */
  page?: 'hub' | 'article';
}

/**
 * Site chrome plus the help centre's own background and tokens.
 */
export const HelpCentreLayout = ({
  children,
  page = 'hub',
}: HelpCentreLayoutProps): React.JSX.Element => (
  <>
    <SiteHeader />
    <div className={page === 'article' ? 'hc hc-article-page' : 'hc'}>{children}</div>
    <SiteFooter />
  </>
);

export default HelpCentreLayout;
